"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _props = require("./props");
Object.keys(_props).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _props[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _props[key];
    }
  });
});
var _programType = require("./programType");
Object.keys(_programType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _programType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _programType[key];
    }
  });
});
var _program = require("./program");
Object.keys(_program).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _program[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _program[key];
    }
  });
});